import { render, staticRenderFns } from "./education-form.vue?vue&type=template&id=c557d018&scoped=true&"
import script from "./education-form.vue?vue&type=script&lang=js&"
export * from "./education-form.vue?vue&type=script&lang=js&"
import style0 from "./education-form.vue?vue&type=style&index=0&id=c557d018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c557d018",
  null
  
)

export default component.exports